import React, { useMemo } from 'react';

import { isGuestOrFreemiumUser } from '../../utils/getUserDetails';

import { FREE_USER_FOOTER_LINKS, GUEST_FOOTER_LINKS } from './FooterLinks';


function MemberFooterLinks(props) {
  const { isAnchor, user, shouldHideAffiliatesLink, isFreemiumUser } = props;
  const isGuestOrFreeUser = isGuestOrFreemiumUser(user);

  const linksToMap = useMemo(() => {
    if (!user?.authenticated) {
      return GUEST_FOOTER_LINKS;
    }
    if (isFreemiumUser) {
      return FREE_USER_FOOTER_LINKS;
    }

    return null;
  }, [user, isFreemiumUser]);

  if (!isGuestOrFreeUser) {
    return (
      <>
        <div className="col-xs-12 text-center">
          <ul className="list-unstyled">
            {!isAnchor && (<li className=" ">
              <a href="/account/purchase">
                Join Naked News
              </a>
            </li>)}
            <li className=" ">
              <a href="/home">Today&#39;s Show</a>
            </li>
            <li className=" ">
              <a href="/naked-amateur-auditions">
                Amateur Auditions
              </a>
            </li>
            <li className="">
              <a href="/archives">Archives</a>
            </li>
            <li className="">
              <a href="/media">Media</a>
            </li>
          </ul>
        </div><div className="col-xs-12 text-center">
          <ul className="list-unstyled">
            <li className=" ">
              <a href="/contact">Contact Us</a>
            </li>
            {user.authenticated && (
              <li className=" ">
                <a href="/account">My Account</a>
              </li>
            )}
            {(user.authenticated && !isAnchor) && (
              <li className=" ">
                <a href="/account/subscriptions">
                  Cancel Subscription
                </a>
              </li>
            )}
            <li className=" ">
              <a href="/faq">F.A.Q.</a>
            </li>
            <li className=" ">
              <a href="/privacy_policy">Privacy Policy</a>
            </li>
            <li className=" ">
              <a href="/cookie-policy">Cookie Policy</a>
            </li>
            <li className=" ">
              <a href="/cookie-settings">
                Cookie Settings
              </a>
            </li>
            <li className=" ">
              <a href="/terms_of_service">
                Terms and Conditions
              </a>
            </li>
            {!shouldHideAffiliatesLink && <li className=" ">
              <a href="/affiliates" rel="noopener noreferrer" target="_blank">
                Affiliates
              </a>
            </li>}
            <li className=" ">
              <a href="/billing/processing">
                Billing Support
              </a>
            </li>
            <li className=" ">
              <a
                href="https://www.mrskin.com/tour?_atc=888591-2-1"
                rel="noopener noreferrer"
                target="_blank"
              >
                Mr. Skin
              </a>
            </li>
            <li className=" ">
              <a href="/2257">18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement</a>
            </li>
          </ul>
        </div>
      </>
    );
  }

  return (
    <div className="col-xs-12 text-center">
      <ul className="list-unstyled">
        {linksToMap.map((link) => (
          <li key={link.url} className=" ">
            <a href={link.url} rel={link.rel || ''}target={link.target}>{link.title}</a>
          </li>
        )
        )}
      </ul>
    </div>
  );
}

export default MemberFooterLinks;
